import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { GetIpdEntryById } from "../../../../api/ipd/ipdEntryAPI";
import { UncontrolledTooltip } from "reactstrap";
import formatDateTime from "../../../../utils/dateFormatter";

const IpdReceipt = () => {
  const { id } = useParams();
  const [ipd, setIpd] = useState(null);
  const printRef = useRef();

  useEffect(() => {
    fetchIpd();
  }, []);

  const fetchIpd = async () => {
    const res = await GetIpdEntryById(id);
    if (res.success) {
      setIpd(res.data);
    }
  };

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const printWindow = window.open("", "", "height=600");

    printWindow.document.write(`
      <html>
        <head>
          <title>IPD Registration Receipt</title>
          <style>
            @page { margin: 1cm; }
            body {
              margin: 1cm;
              font-family: Arial, sans-serif;
              font-size: 14px;
            }
            table { width: 100%; }
          </style>
        </head>
        <body>
          ${printContents}
          <script>
            window.onload = function() {
              window.print();
              window.onafterprint = function() {
                window.close();
              };
            }
          </script>
        </body>
      </html>
    `);

    printWindow.document.close();
  };

  if (!ipd) return <p>Loading...</p>;

  const advance = ipd.advance || 0;

  return (
    <>
      {/* ACTION BUTTONS */}
      <div style={{ textAlign: "right", marginTop: "100px", marginBottom: "15px" }}>
        <button
          id="print"
          className="btn btn-info me-2"
          onClick={handlePrint}
        >
          <i className="fa fa-print" /> Print Receipt
        </button>
        <UncontrolledTooltip target="print">
          Print IPD Receipt
        </UncontrolledTooltip>

        <Link to="/ipd/transaction/ipd-entry/list">
          <button className="btn btn-primary" id="list">
            IPD Entry List
          </button>
          <UncontrolledTooltip target="list">
            IPD Entry List
          </UncontrolledTooltip>
        </Link>
      </div>

      {/* RECEIPT */}
      <div
        ref={printRef}
        style={{
          width: "90%",
          margin: "auto",
          fontFamily: "Arial, sans-serif",
          fontSize: "14px"
        }}
      >
        {/* HEADER */}
        <table width="100%" style={{ borderCollapse: "collapse" }}>
          <tbody>
            <tr>
              {/* 1. Logo Cell */}
              <td width="10%" style={{ textAlign: "right" }}>
                <img
                  src="/logo.png"
                  alt="logo"
                  style={{ width: "150px" }}
                />
              </td>

              {/* 2. Perfectly Centered Text */}
              <td style={{ textAlign: "center" }}>
                <h2 style={{ margin: 0 }}>{ipd.companyId?.name}</h2>
                <h5>{ipd.companyId?.address}</h5>
                <h5>({ipd.companyId?.description || "Healthcare institution providing specialized medical, nursing, and diagnostic care to patients."})</h5>
                <strong>IPD REGISTRATION RECEIPT</strong>
              </td>

              {/* 3. Buffer Cell (Same width as logo cell to balance the center) */}
              <td width="10%"></td>
            </tr>
          </tbody>
        </table>

        <br />

        {/* BASIC INFO */}
        <table width="100%">
          <tbody>
            <tr>
              <td width="50%">
                <strong>IPD No.:</strong> {ipd.ipdNo}
              </td>
              <td width="50%" style={{ textAlign: "right" }}>
                <strong>Date & Time:</strong>{" "}
                {ipd.date?.split("T")[0]} {ipd.time}
              </td>
            </tr>

            <tr>
              <td>
                <strong>UHID No.:</strong> {ipd.patientId?.uhidNo}
              </td>
              <td style={{ textAlign: "right" }}>
                {
                  ipd.ipdDirection === "No" &&
                  <>
                    <strong>OPD No.:</strong> {ipd.opdEntryId?.opdNo || "-"}
                  </>
                }
              </td>
            </tr>

            <tr>
              <td>
                <strong>Patient Name:</strong>{" "}
                {ipd.patientId?.patientNamePrefix} {ipd.patientId?.patientName}
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>Age / Sex:</strong>{" "}
                {ipd.patientId?.age} {ipd.patientId?.ageSuffix} / {ipd.patientId?.sex}
              </td>
            </tr>

            <tr>
              <td>
                <strong>Consultant:</strong>{" "}
                {ipd.consultantDoctorId?.name}
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>Department:</strong>{" "}
                {ipd.departmentId?.name}
              </td>
            </tr>

            <tr>
              <td>
                <strong>Room:</strong> {ipd.roomId?.roomNo}
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>Case:</strong> {ipd.caseId?.name}
              </td>
            </tr>
          </tbody>
        </table>

        <hr />

        {/* PAYMENT INFO */}
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <strong>Payment Mode:</strong> {ipd.paymentMode}
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>Advance Amount:</strong> {advance.toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>

        <br />

        {/* FOOTER */}
        <table width="100%">
          <tbody>
            <tr>
              <td>
                <strong>Prepared By:</strong> Admin
              </td>
              <td style={{ textAlign: "right" }}>
                <strong>Authorized Signatory</strong>
              </td>
            </tr>
          </tbody>
        </table>

        <hr />

        <p style={{ textAlign: "end", fontSize: "12px" }}>
          Printed On: {formatDateTime(new Date())}
        </p>
        <p style={{ textAlign: "end", fontSize: "12px" }}>
          Not Valid For Medicolegal Purposes
        </p>
      </div>
    </>
  );
};

export default IpdReceipt;
